import * as React from 'react'

// 164×100 per Figma 12146:257292. Live overlay is absolutely positioned so
// it can swap in/out without reflowing surrounding content.

interface IProps {
  src?: string
  alt: string
  isLive?: boolean
  /** Receives the same 164×100 frame as the baseline. */
  renderLivePreview?: () => React.ReactNode
}

export const MapViewsSidebarThumbnail: React.FC<IProps> = ({
  src,
  alt,
  isLive,
  renderLivePreview,
}) => (
  <div className="tw:relative tw:h-[100px] tw:w-[164px] tw:shrink-0 tw:overflow-hidden tw:rounded-[4px]">
    {src ? (
      <img
        src={src}
        alt={alt}
        className="tw:block tw:h-full tw:w-full tw:object-cover tw:rounded-[4px]"
        draggable={false}
      />
    ) : (
      <div
        className="tw:h-full tw:w-full tw:bg-muted tw:rounded-[4px]"
        aria-hidden="true"
      />
    )}
    {isLive && renderLivePreview && (
      <div
        className="tw:absolute tw:inset-0 tw:rounded-[4px] tw:overflow-hidden"
        aria-hidden="true"
      >
        {renderLivePreview()}
      </div>
    )}
  </div>
)
